import { OnInit, Component, AfterViewChecked } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from "primeng/primeng";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../../../shared/web-page";
import { Indicacao } from "../../../../../models/indicacao.model";
import { AuthService } from "../../../../admin/auth.service";
import { EmpresaService } from "../../../../../services/empresa.service";
import { Perfis } from "../../../../../models/perfis";
import { Util } from "../../../../shared/util";
import { Empresa } from "../../../../../models/empresa.model";
import { Vaga } from "../../../../../models/vaga.model";
import { Categoria } from "../../../../../models/categoria";
import { InscricaoService } from "../../../../../services/inscricao.service";

@Component({
  selector: 'gerenciar-indicacao',
  templateUrl: './gerenciar-indicacao.component.html',
})

export class GerenciarIndicadoComponent extends WebPage implements OnInit, AfterViewChecked {

  isLoading: boolean =false;
  usuario: any = {};
  perfis: any = {};
  
  // Controle das abas
  activeTab: string = 'indicacoes';
  isEditMode: boolean = false;
  
  form: FormGroup = {} as FormGroup;
  formIndicacao: FormGroup = {} as FormGroup;
  formEmpresa: FormGroup = {} as FormGroup;
  formMudarCategoria: FormGroup = {} as FormGroup;
  listaIndicacoes: Indicacao[] = [];
  registroModal: Indicacao = null;

  // Propriedades para o modal de mudar categoria
  vagaSelecionada: any = null;
  categoriasSelecionadas: string[] = [];
  hoje = new Date().toISOString().split('T')[0];

  public empresa: Empresa;
  public inputCpf: string;
  public inputNome: string;

  public tipoDocumentoCpf: string = 'cpf'; // padrão inicial
  public totalIndicacoes = 0;
  public totalVagas = 0;

  listaTipoEmpresas: any[];
  listaTipoSetores: any[];
  categorias: Categoria[] = [];

  constructor(
    private _router: Router,
    messageService: MessageService,
    private fb: FormBuilder,
    private authService: AuthService,
    private _empresaService: EmpresaService,
    private _insricaoService: InscricaoService,
    private confirmationService: ConfirmationService,
  ){
      super(messageService);
  }
  
  ngAfterViewChecked(): void {
    //throw new Error("Method not implemented.");
  }
  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;
    this.empresa = this.authService.informacoesUsuarioEmpresa();
    this.criarForm();
    this.criarFormIndicacao();
    this.criarFormEmpresa();
    this.criarFormMudarCategoria();
    this.getChangeCpf();
    this.pesquisar();
    this.carregarEmpresa();
    this.carregarTipos();
    this.carregarCategorias();
    
  }
  carregarEmpresa(){
    this.totalVagas = 0;
    this._empresaService.getEmpresaById(this.empresa.idEmpresa)
    .subscribe(
      (response: Empresa) => {
        this.empresa = response;
        // this.empresa.vagas.forEach(
        //   (vaga: Vaga) => {
        //     this.totalVagas += vaga.numeroVagas;
        //   }
        // )
         console.log('Empresa Carregada -> ', this.empresa);
         this.totalVagas = this.empresa.totalVagaUnidade;
         if(this.getTotalVagaDisponiveis() >= 0){
           this.totalIndicacoes = this.getTotalVagaDisponiveis();
         }
         // Preencher o formulário da empresa
         this.preencherFormEmpresa();
      }
    );
  }

  private preencherFormEmpresa() {
    if (this.empresa) {
      this.formEmpresa.patchValue({
        idTipoEmpresa: this.empresa.idTipoEmpresa || '',
        idTipoSetor: this.empresa.idTipoSetor || '',
        cnpj: this.empresa.cnpj || '',
        razaoSocial: this.empresa.razaoSocial || '',
        nomeFantasia: this.empresa.nomeFantasia || '',
        telefone: this.empresa.telefone || '',
        email: this.empresa.email || '',
        cep: this.empresa.cep || '',
        uf: this.empresa.uf || '',
        cidade: this.empresa.cidade || '',
        logradouro: this.empresa.logradouro || '',
        numero: this.empresa.numero || '',
        bairro: this.empresa.bairro || '',
        responsavelNome: this.empresa.responsavelNome || '',
        cpf: this.empresa.cpf || '',
        responsavelCargo: this.empresa.responsavelCargo || '',
        responsavelEmail: this.empresa.responsavelEmail || '',
        responsavelTelefone: this.empresa.responsavelTelefone || ''
      });
    }
  }

  salvarEmpresa() {
    if (this.formEmpresa.valid) {
      const dadosEmpresa = this.formEmpresa.value;
      
      // Atualiza os dados da empresa com os valores do formulário
      Object.assign(this.empresa, dadosEmpresa);
      
      // Prepara o objeto empresa para envio, incluindo as categorias atualizadas
      const empresaParaEnvio = {
        ...this.empresa,
        vagas: this.empresa.vagas.map(vaga => ({
          ...vaga,
          vagaCategorias: vaga.vagaCategorias || []
        }))
      };
      
      console.log('Dados da empresa para salvar:', empresaParaEnvio);
      
      this.isLoading = true;
      
      // Chama o serviço para atualizar a empresa
      this._empresaService.updateEmpresa(empresaParaEnvio, this.usuario).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success', 
            summary: 'Sucesso', 
            detail: 'Empresa atualizada com sucesso! Todas as alterações, incluindo categorias, foram salvas.'
          });
          
          // Recarrega os dados da empresa para refletir as mudanças
          this.carregarEmpresa();
          this.isEditMode = false;
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Erro ao salvar empresa:', error);
          this.messageService.add({
            severity: 'error', 
            summary: 'Erro', 
            detail: 'Erro ao atualizar empresa. Tente novamente.'
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'warn', 
        summary: 'Atenção', 
        detail: 'Por favor, preencha todos os campos obrigatórios'
      });
    }
  }
    private criarForm() {
      this.form = this.fb.group({
        cpf: [''],
        nome: [''],
      });
      this.pesquisar();
    }

    private criarFormIndicacao() {
      this.formIndicacao = this.fb.group({
        cpf: ['',[Validators.required,Validators.pattern(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/), this.documentoValidatorCpf()]],
        nome: ['',[Validators.required]],
      });
    }

    private criarFormEmpresa() {
      this.formEmpresa = this.fb.group({
        idTipoEmpresa: [''],
        idTipoSetor: [''],
        cnpj: [''],
        cpf: [''],
        razaoSocial: [''],
        nomeFantasia: [''],
        telefone: [''],
        email: [''],
        cep: [''],
        uf: [''],
        cidade: [''],
        logradouro: [''],
        numero: [''],
        bairro: [''],
        responsavelNome: [''],
      responsavelCargo: [''],
      responsavelEmail: [''],
      responsavelTelefone: ['']
      });
    }

    private criarFormMudarCategoria() {
      this.formMudarCategoria = this.fb.group({
        uf: [''],
        cidade: [''],
        numeroVagas: ['']
      });
    }

    carregarTipos(){
    this._empresaService.getListaTipoEmpresa().subscribe(
      response => {
        if(response){
          console.log('Tipos EMpresa carregaods ->',response);
          this.listaTipoEmpresas = response.map((x) => {
            return {label: x.descricao, value: x.idTipoEmpresa}
          })
        }
      },
      error => {
        console.error(error);
      }
    )
    this._empresaService.getListaTipoSetor().subscribe(
      response => {
        if(response){
          //console.log(response);
          this.listaTipoSetores = response.map((x) => {
            return {label: x.descricao, value: x.idTipoSetor}
          })
        }
      },
      error => {
        console.error(error);
      }
    )
  }
  carregarCategorias(){
    this._insricaoService.getListaCategoria().subscribe(
      response => {
        if(response){
          this.categorias = response.filter(c => c.idCategoria.toUpperCase() !== '4B3B98B5-6DDA-492E-AFBD-FBAAB06E01E2');
        }
      }
    )
  }

    getChangeCpf(){
      // Acompanhar as mudanças no campo CPF e aplicar a máscara
      this.formIndicacao.get('cpf').valueChanges.subscribe(value => {
        if (value) {
          // Remove caracteres não numéricos
          let numericValue = value.replace(/\D/g, '');
          
          // Limita a 11 dígitos (CPF)
          numericValue = numericValue.substring(0, 11);
          
          // Aplica a máscara CPF (XXX.XXX.XXX-XX)
          let maskedValue = numericValue;
          
          if (numericValue.length > 3) {
            maskedValue = numericValue.substring(0, 3) + '.' + numericValue.substring(3);
          }
          
          if (numericValue.length > 6) {
            maskedValue = maskedValue.substring(0, 7) + '.' + maskedValue.substring(7);
          }
          
          if (numericValue.length > 9) {
            maskedValue = maskedValue.substring(0, 11) + '-' + maskedValue.substring(11);
          }
          
          // Atualiza o campo com o valor mascarado sem disparar outro evento valueChanges
          this.formIndicacao.get('cpf').setValue(maskedValue, { emitEvent: false });
        }
      });
    }

    pesquisar() {
      this.isLoading = true;
      this.messageService.clear();
      let pesquisa = this.montarObjetoPesquisa();
      try{
        pesquisa = Util.limpaCpf(pesquisa);
      }catch{}
      this._empresaService.getIndicacaoByAll(pesquisa, this.empresa.idEmpresa)
      .finally( 
        () => { this.isLoading = false;}
      )
      .subscribe(
        (v)=>{
          console.log(v);
          this.listaIndicacoes = v;
          if(this.getTotalVagaDisponiveis() >= 0){
            this.totalIndicacoes = this.getTotalVagaDisponiveis();
          }
        },
        (error) => {
        this.isLoading = false;
        this.gerenciaErro(error)
      });
    }
    getTotalVagaDisponiveis(){
       return (this.totalVagas - this.listaIndicacoes.length);
    }
    isEmptyReturnNull(value: any){
        if(value === null ||value === '') {
          return null;
        }
        return value;
    }
    montarObjetoPesquisa(): string{
      let dado = '';
      if(this.isEmptyReturnNull(this.form.get('cpf').value)){
        dado = this.form.get('cpf').value;
      }else if(this.isEmptyReturnNull(this.form.get('nome').value)){
        dado = this.form.get('nome').value;
      }        
      return dado;
    }

    abrirModalDetalhes(registroSelecionado : any) {
      if(this.getTotalVagaDisponiveis() <= 0) return;
      if(registroSelecionado){
        this.registroModal = registroSelecionado;
        this.inputCpf = this.registroModal.cpf;
        this.inputNome = this.registroModal.nome;
      }else{
        this.registroModal = null;
        this.limparDados();
      }
    }
    salvarIndicacao(){
      if(this.getTotalVagaDisponiveis() <= 0) return;
      if(this.registroModal != null){
        this.isLoading = true;
        if(this.isEmptyReturnNull(this.formIndicacao.controls.cpf.value) == null) return;
        if(Util.isCpf(this.formIndicacao.controls.cpf.value) == false) return;
        if(this.isEmptyReturnNull(this.formIndicacao.controls.nome.value) == null) return;
        if(this.isEmptyReturnNull(this.empresa.idEmpresa) == null) return;

        this.registroModal.idEmpresa = this.empresa.idEmpresa;
        this.registroModal.cpf = Util.limpaCpf(this.formIndicacao.controls.cpf.value);
        this.registroModal.nome = this.formIndicacao.controls.nome.value;
        
        this._empresaService.updateIndicacao(this.registroModal,'').finally(
          () => this.isLoading = false
        )
        .subscribe(
          (v) => {
             if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Salvo',
                    detail: 'Indicação salva com sucesso',
                  }
                )
                this.pesquisar();
                this.getTotalVagaDisponiveis();
              }
          }
        );
      }else{
        this.isLoading = true;
        this.registroModal = {
          idIndicacao: '00000000-0000-0000-0000-000000000000',
          idEmpresa: this.empresa.idEmpresa,
          cpf : Util.limpaCpf(this.formIndicacao.controls.cpf.value),
          nome : this.inputNome,
          ativo: true,
          dataCadastro: null,
          empresa: null,
        }    
        this._empresaService.inserirIndicacao(this.registroModal).finally(
          () => {this.isLoading = false; this.pesquisar();}
        )
        .subscribe(
          (v) => {
             if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Salvo',
                    detail: 'Indicação salva com sucesso',
                  }
                )
                this.limparDados();
              }
          },
          (error) => {
            this.gerenciaErro(error);
          }
        );
      }
    }
    remover(selecionado){
      this.registroModal = selecionado;
    }
    removerIndicacao(){
      //if(confirm('Deseja remover a indicação?')){
        this.isLoading = true;
          this._empresaService.removerIndicacaoByCpf(Util.limpaCpf(this.registroModal.cpf))
          .finally(
            () => this.isLoading = false )
          .subscribe(
            (v) => {
              if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Removido',
                    detail: 'Indicação removida com sucesso',
                  }
                )
                this.pesquisar();
              }
            },
            (error) => {
              this.gerenciaErro(error);
            });
      //}
    }
    limparDados(){
      this.inputCpf = "";
      this.inputNome = "";
      this.registroModal = null;
    }
    voltar() {
      this._router.navigate(['/indicacao']);
    }

    documentoValidatorCpf() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      
      if (!value) {
        return null;
      }

      // Remove caracteres não numéricos para validação
      const numeros = value.replace(/\D/g, '');
      // Verifica qual validação aplicar com base no tipo de documento selecionado
      if (this.tipoDocumentoCpf === 'cpf') {
        return Util.isCpf(numeros) ? null : { cpfInvalido: true };
      }
    };
  }

  // Métodos para controlar as abas
  setActiveTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'propostas') {
      this.isEditMode = false; // Reset edit mode when switching to propostas
    }
  }

  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  editarCadastro() {
    this.isEditMode = true;
  }

  cancelarEdicao() {
    this.isEditMode = false;
    // Aqui você pode adicionar lógica para reverter as alterações se necessário
  }

  salvarCadastro() {
    // Aqui você pode adicionar lógica para salvar as alterações
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Cadastro salvo com sucesso!'
    });
    this.isEditMode = false;
  }

  // Métodos auxiliares para obter descrições
  getTipoEmpresaDescricao(): string {
    const tipo = this.listaTipoEmpresas.find(t => t.value === this.empresa.idTipoEmpresa);
    return tipo ? tipo.label : '';
  }

  getTipoSetorDescricao(): string {
    const setor = this.listaTipoSetores.find(s => s.value === this.empresa.idTipoSetor);
    return setor ? setor.label : '';
  }

  getCategoriasVaga(vaga: any): string {
    // Log para debug - remover depois
    console.log('Vaga completa:', vaga);
    console.log('vagaCategorias:', vaga.vagaCategorias);
    
    // Verifica se existe o array vagaCategorias (plural)
    if (vaga.vagaCategorias && Array.isArray(vaga.vagaCategorias)) {
      const categoriasNomes = vaga.vagaCategorias.map(vagaCat => {
        console.log('vagaCat:', vagaCat);
        // Acessa a categoria dentro de cada vagaCategoria
        if (vagaCat.categoria && vagaCat.categoria.descricao) {
          return vagaCat.categoria.descricao;
        }
        return '';
      }).filter(nome => nome !== '');
      
      return categoriasNomes.join(', ');
    }
    
    // Fallback: Se categorias é um array de IDs (estrutura antiga)
    if (Array.isArray(vaga.categorias)) {
      const categoriasNomes = vaga.categorias.map(catId => {
        const categoria = this.categorias.find(c => c.idCategoria === catId);
        return categoria ? categoria.descricao : '';
      }).filter(nome => nome !== '');
      
      return categoriasNomes.join(', ');
    }
    
    // Fallback: Se categorias é uma string separada por vírgula
    if (typeof vaga.categorias === 'string') {
      return vaga.categorias;
    }
    
    return 'Nenhuma categoria';
  }

  // Métodos para o modal de mudar categoria
  abrirModalMudarCategoria(vaga: any) {
    this.vagaSelecionada = vaga;
    this.categoriasSelecionadas = [];
    
    // Preenche o formulário com os dados da vaga
    this.formMudarCategoria.patchValue({
      uf: vaga.uf || '',
      cidade: vaga.cidade || '',
      numeroVagas: vaga.numeroVagas || 0
    });
    
    // AJUSTE 1: Marca as categorias já selecionadas (preenche previamente)
    if (vaga.vagaCategorias && Array.isArray(vaga.vagaCategorias)) {
      this.categoriasSelecionadas = vaga.vagaCategorias.map(vagaCat => 
        vagaCat.categoria ? vagaCat.categoria.idCategoria : null
      ).filter(id => id !== null);
    }
    
    // Atualiza os checkboxes
    setTimeout(() => {
      this.atualizarCheckboxes();
    }, 100);
  }
  
  atualizarCheckboxes() {
    this.categorias.forEach(categoria => {
      const checkbox = document.getElementById('categoria_' + categoria.idCategoria) as HTMLInputElement;
      if (checkbox) {
        checkbox.checked = this.categoriasSelecionadas.includes(categoria.idCategoria);
      }
    });
  }
  
  onCategoriaChange(event: any, categoria: any) {
    const isChecked = event.target.checked;
    const categoriaId = categoria.idCategoria;
    
    if (isChecked) {
      // Adiciona a categoria se não estiver já selecionada
      if (!this.categoriasSelecionadas.includes(categoriaId)) {
        this.categoriasSelecionadas.push(categoriaId);
      }
    } else {
      // Remove a categoria desmarcada
      const index = this.categoriasSelecionadas.indexOf(categoriaId);
      if (index > -1) {
        this.categoriasSelecionadas.splice(index, 1);
      }
    }
    
    console.log('Categorias selecionadas:', this.categoriasSelecionadas);
  }
  
  confirmarMudarCategoria() {
    if (!this.vagaSelecionada) return;
    
    // Validação: pelo menos uma categoria deve ser selecionada
    if (this.categoriasSelecionadas.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione pelo menos uma categoria!'
      });
      return;
    }
    
    console.log('Vaga selecionada:', this.vagaSelecionada);
    console.log('Categorias selecionadas:', this.categoriasSelecionadas);
    
    // Atualiza apenas o array vagaCategorias da vaga selecionada no objeto empresa local
    // Isso permite que as mudanças sejam salvas junto com o resto da empresa
    this.vagaSelecionada.vagaCategorias = this.categoriasSelecionadas.map(catId => {
      const categoria = this.categorias.find(c => c.idCategoria.toString() === catId.toString());
      return {
        idVagaCategoria: null, // Será gerado pelo backend ao salvar
        idVaga: this.vagaSelecionada.idVaga,
        idCategoria: catId,
        categoria: categoria ? {
          idCategoria: categoria.idCategoria,
          descricao: categoria.descricao
        } : null
      };
    });
    
    // Atualiza também a vaga correspondente no objeto empresa para manter consistência
    if (this.empresa && this.empresa.vagas) {
      const vagaIndex = this.empresa.vagas.findIndex(v => v.idVaga === this.vagaSelecionada.idVaga);
      if (vagaIndex !== -1) {
        this.empresa.vagas[vagaIndex].vagaCategorias = this.vagaSelecionada.vagaCategorias;
      }
    }
    
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Categorias atualizadas! Lembre-se de salvar as alterações da empresa.'
    });
    
    this.cancelarMudarCategoria();
  }
  
  cancelarMudarCategoria() {
    this.vagaSelecionada = null;
    this.categoriasSelecionadas = [];
    this.formMudarCategoria.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/indicacao/gerenciar-indicacao/gerenciar-indicacao.component.ts